

import Login from './loginParceiro'
import Promocoes from './promocoes'
import Usuarios from './usuarios'
import Perfil from './perfil'
import Cupons from './cupons'
import Relatorio from './relatorio'

export default {
    ...Cupons, 
    ...Perfil, 
    ...Promocoes, 
    ...Usuarios, 
    ...Login, 
    ...Relatorio, 
}